import { render, staticRenderFns } from "./StatichtmlProps.vue?vue&type=template&id=354e50ae"
import script from "./StatichtmlProps.vue?vue&type=script&lang=js"
export * from "./StatichtmlProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports